import { useAppTranslation } from "@/utils";
import { Button, Col, Drawer, Flex, Grid, Page, Row, Typography } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import { Close, DownloadOutlined, Lock } from "@payping/icons";
import { cancelId, closeId, fileDownloadId } from "@/assets/googleTrackIds";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";

const GetAccessAccount = () => {
  const { t } = useAppTranslation();
  const { md } = Grid.useBreakpoint();
  return (
    <>
      <Drawer
        title={<Typography.Text>{t("digitalAccount.gettingAccessToTheSamanJointAccount.title")}</Typography.Text>}
        open={true}
        closeIcon={false}
        height={"100%"}
        placement={"bottom"}
        extra={
          <Link to={DashboardRoutes.digitalAccount.saman.newAccount.offline?.url}>
            <Button type={"text"} icon={<Close width={14} height={14} />} data-google-track={closeId} />
          </Link>
        }
      >
        <Page>
          <SubLayout>
            <Flex vertical gap={64}>
              <div className="!tw-flex !tw-justify-center">
                <Flex vertical gap={16}>
                  <div className="!tw-flex !tw-justify-center">
                    <Lock width={84} />
                  </div>
                  <Typography.Title level={4}>
                    {t("digitalAccount.gettingAccessToTheSamanJointAccount.title")}
                  </Typography.Title>
                </Flex>
              </div>
              <Typography.Text className="!tw-flex !tw-justify-center tw-whitespace-pre-line">
                {t("digitalAccount.gettingAccessToTheSamanJointAccount.desc")}
              </Typography.Text>
              {md ? (
                <Flex className="!tw-flex !tw-justify-center" gap={16}>
                  <Link to={DashboardRoutes.digitalAccount.saman.access.getInfo.url}>
                    <Button
                      type={"primary"}
                      icon={<DownloadOutlined width={14} height={14} />}
                      data-google-track={fileDownloadId}
                    >
                      {t("digitalAccount.gettingAccessToTheSamanJointAccount.continue")}
                    </Button>
                  </Link>
                  <Link to={DashboardRoutes.digitalAccount.saman.accountConnection?.url} data-google-track={cancelId}>
                    <Button type={"default"}>{t("cancel")}</Button>
                  </Link>
                </Flex>
              ) : null}
            </Flex>
          </SubLayout>
        </Page>
      </Drawer>
      {!md ? (
        <Drawer open={true} closable={false} mask={false} height={80} placement={"bottom"}>
          <Row gutter={[8, 8]}>
            <Col flex={3}>
              <Link to={DashboardRoutes.digitalAccount.saman.access.getInfo.url}>
                <Button
                  block
                  type={"primary"}
                  icon={<DownloadOutlined width={14} height={14} />}
                  data-google-track={fileDownloadId}
                >
                  {t("digitalAccount.gettingAccessToTheSamanJointAccount.continue")}
                </Button>
              </Link>
            </Col>
            <Col flex={1}>
              <Link to={DashboardRoutes.digitalAccount.saman.accountConnection?.url} data-google-track={cancelId}>
                <Button block type={"default"}>
                  {t("cancel")}
                </Button>
              </Link>
            </Col>
          </Row>
        </Drawer>
      ) : null}
    </>
  );
};

export default GetAccessAccount;
